export class JsReportPage {
    page: string;

    constructor(pageContents: string) {
        this.page = pageContents;
    }
}
